import React, { useContext, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "../../services/api";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import { HeyatYoluContext } from "../../App";
import Cookies from "js-cookie";
import "./styles/Register.css";

function Register() {
  const navigate = useNavigate();
  const { setUser } = useContext(HeyatYoluContext);

  const [form, setForm] = useState({
    fullName: "",
    email: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    if (error) setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const referralCode = Cookies.get("referralCode") || null;

      await axios.post("/account/register", {
        ...form,
        referralCode: referralCode,
      });

      const loginRes = await axios.post("/account/login", {
        email: form.email,
        password: form.password,
      });

      setUser(loginRes.data.user);
      toast.success("Qeydiyyat və giriş uğurla tamamlandı!");
      navigate("/");

    } catch (err) {
      console.error("Qeydiyyat xətası:", err);

      const serverError = err.response?.data;

      if (Array.isArray(serverError)) {
        setError(serverError.map((e) => e.description).join(" | "));
      } else if (typeof serverError === "string") {
        setError(serverError);
      } else {
        setError("Xəta baş verdi. Zəhmət olmasa, yenidən yoxlayın.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="rg-page">
      <Helmet>
        <title>Qeydiyyat – HeyatYolu</title>
        <meta name="description" content="HeyatYolu platformasında qeydiyyatdan keçin və sevdiklərinizin xatirəsini əbədiləşdirin." />
        <meta property="og:title" content="Qeydiyyat – HeyatYolu" />
        <meta property="og:description" content="HeyatYolu platformasında qeydiyyatdan keçin və sevdiklərinizin xatirəsini əbədiləşdirin." />
        <meta property="og:image" content="https://api.heyatyolu.az/favicon.ico" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="rg-container">
        <div className="rg-card">
          {/* Header Section */}
          <div className="rg-header">
            <div className="rg-icon">
              <i className="fas fa-user-plus"></i>
            </div>
            <h1 className="rg-title">Yeni Hesab Yarat</h1>
            <p className="rg-subtitle">Xatirələr dünyasına qoşulun</p>
          </div>

          {/* Form Section */}
          <form onSubmit={handleSubmit} className="rg-form">
            {/* Full Name Input */}
            <div className="rg-form-group">
              <label htmlFor="fullName" className="rg-form-label">
                <i className="fas fa-user"></i>
                Ad və Soyad
              </label>
              <input
                id="fullName"
                type="text"
                name="fullName"
                placeholder="Adınızı və soyadınızı daxil edin"
                required
                value={form.fullName}
                onChange={handleChange}
                className="rg-form-input"
                autoComplete="name"
              />
            </div>

            {/* Email Input */}
            <div className="rg-form-group">
              <label htmlFor="email" className="rg-form-label">
                <i className="fas fa-envelope"></i>
                Email
              </label>
              <input
                id="email"
                type="email"
                name="email"
                placeholder="email@example.com"
                required
                value={form.email}
                onChange={handleChange}
                className="rg-form-input"
                autoComplete="email"
              />
            </div>

            {/* Password Input */}
            <div className="rg-form-group">
              <label htmlFor="password" className="rg-form-label">
                <i className="fas fa-lock"></i>
                Şifrə
              </label>
              <div className="rg-password-wrapper">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Minimum 6 simvol"
                  required
                  minLength="6"
                  value={form.password}
                  onChange={handleChange}
                  className="rg-form-input"
                  autoComplete="new-password"
                />
                <button
                  type="button"
                  className="rg-password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label="Toggle password visibility"
                >
                  <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>
              </div>
              <small className="rg-password-hint">
                <i className="fas fa-info-circle"></i>
                Şifrə ən azı 6 simvoldan ibarət olmalıdır
              </small>
            </div>

            {/* Error Message */}
            {error && (
              <div className="rg-error-message">
                <i className="fas fa-exclamation-circle"></i>
                <span>{error}</span>
              </div>
            )}

            {/* Submit Button */}
            <button
              type="submit"
              className="rg-button"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="rg-spinner"></span>
                  Qeydiyyat edilir...
                </>
              ) : (
                <>
                  <i className="fas fa-user-check"></i>
                  Qeydiyyatdan keç
                </>
              )}
            </button>
          </form>

          {/* Divider */}
          <div className="rg-divider">
            <span>və ya</span>
          </div>

          {/* Login Link */}
          <div className="rg-login-section">
            <p className="rg-login-text">
              Artıq hesabınız var?
            </p>
            <Link to="/giris" className="rg-login-link">
              <i className="fas fa-sign-in-alt"></i>
              Daxil ol
            </Link>
          </div>
        </div>

        {/* Decorative Elements */}
        <div className="rg-decoration">
          <div className="rg-decoration-circle rg-circle-1"></div>
          <div className="rg-decoration-circle rg-circle-2"></div>
          <div className="rg-decoration-circle rg-circle-3"></div>
        </div>
      </div>
    </div>
  );
}

export default Register;